import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { authTokenSelector } from '../../session';
import { CARD_DETAILS_ENDPOINT } from './endpoints';

const actions = createActions({
  PAYMENT: {
    GET_CARD_DETAILS: undefined,
    API: {
      GET_CARD_DETAILS: apiResourceActionCreator('cardDetails')
    }
  }
})

export const apiAction = (authToken) => commonApiActions.authenticated.get(CARD_DETAILS_ENDPOINT, authToken, actions.payment.api.getCardDetails)

export function* fetchCardDetails(action) {
  const authToken = yield select(authTokenSelector);
  yield put(apiAction(authToken));
}

const configuration = {
  name: 'getCardDetails',
  action: actions,
  sagas: fetchCardDetails,
  reducers: {
    request: (state, action) => ({
      ...state,
      isFetching: true
    }),
    success: (state, action) => ({
      ...state,
      isFetching: false,
      cardDetails: action.payload.cardDetails
    }),
    failed: (state, action) => ({
      ...state,
      isFetching: false,
      error: action.payload.error
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/payment/configurations/getCardDetails.js